
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kBWmB", function(module, exports) {

$parcel$export(module.exports, "fetchJson", () => $628bbc7f670a215c$export$6d71b655afe1638d);
$parcel$export(module.exports, "fetchJsonWithNetworkRetries", () => $628bbc7f670a215c$export$16566b750080153d);
$parcel$export(module.exports, "postJson", () => $628bbc7f670a215c$export$c776284ef4b1209a);

var $jIyl9 = parcelRequire("jIyl9");

var $9Gu3R = parcelRequire("9Gu3R");

var $03bmy = parcelRequire("03bmy");
const $628bbc7f670a215c$var$extraJsonFromResponse = (response)=>{
    if (response.ok) return response.json();
    throw new (0, $jIyl9.FetchError)(`Unable to fetch ${response.url} ${response.status} ${response.statusText}`, response.status);
};
const $628bbc7f670a215c$export$6d71b655afe1638d = (url, init)=>fetch(url, {
        credentials: 'include',
        ...init,
        headers: {
            'Atl-App-Switcher-Version': (0, $03bmy.default).packageVersion,
            ...init?.headers
        }
    }).then($628bbc7f670a215c$var$extraJsonFromResponse);
const $628bbc7f670a215c$export$16566b750080153d = (url, retryConfig, init)=>{
    return (0, $9Gu3R.retryOnException)(()=>fetch(url, {
            credentials: 'include',
            ...init,
            headers: {
                'Atl-App-Switcher-Version': (0, $03bmy.default).packageVersion,
                ...init?.headers
            }
        }), retryConfig).then($628bbc7f670a215c$var$extraJsonFromResponse);
};
const $628bbc7f670a215c$export$c776284ef4b1209a = (url, data)=>$628bbc7f670a215c$export$6d71b655afe1638d(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });

});
parcelRegister("jIyl9", function(module, exports) {

$parcel$export(module.exports, "FETCH_ERROR_NAME", () => $c1dbd2effcc8e151$export$83179404a61b001a);
$parcel$export(module.exports, "FetchError", () => $c1dbd2effcc8e151$export$26e841bcf1aeb894);
const $c1dbd2effcc8e151$export$83179404a61b001a = 'FetchError';
class $c1dbd2effcc8e151$export$26e841bcf1aeb894 extends Error {
    static isFetchError(value) {
        return value instanceof $c1dbd2effcc8e151$export$26e841bcf1aeb894;
    }
    constructor(message, status){
        super(message);
        this.status = void 0;
        this.name = $c1dbd2effcc8e151$export$83179404a61b001a;
        this.status = status;
    }
}

});

parcelRegister("9Gu3R", function(module, exports) {

$parcel$export(module.exports, "retryOnException", () => $21671ff65c1374e7$export$1d94629c94e7a17f);
const $21671ff65c1374e7$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $21671ff65c1374e7$export$1d94629c94e7a17f = async (invokeOperation, config)=>{
    let nextMSInterval = 0;
    let error = new Error('No calls made');
    const retries = config.intervalsMS.length;
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) {
            await $21671ff65c1374e7$export$5c069c93d2b7493f(nextMSInterval);
            if (config.onRetry) config.onRetry(error, retries - config.intervalsMS.length);
        }
        return await invokeOperation();
    } catch (e) {
        error = e;
        if (config.shouldRetryOnException && !config.shouldRetryOnException(error)) throw error;
        nextMSInterval = config.intervalsMS.shift();
    }
    throw error;
};

});

parcelRegister("03bmy", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc7959e6d06e21c8$export$2e2bcd8739ae039);
const $dc7959e6d06e21c8$var$packageName = "platform-pkg";
const $dc7959e6d06e21c8$var$packageVersion = "0.0.0-use.local";
var $dc7959e6d06e21c8$export$2e2bcd8739ae039 = {
    packageName: $dc7959e6d06e21c8$var$packageName,
    packageVersion: $dc7959e6d06e21c8$var$packageVersion
};

});


parcelRegister("irYQs", function(module, exports) {

$parcel$export(module.exports, "Status", () => $d479263545be1416$export$96e9906d6d93a972);
$parcel$export(module.exports, "isComplete", () => $d479263545be1416$export$9569565a7ac14e8e);
$parcel$export(module.exports, "isError", () => $d479263545be1416$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "hasLoaded", () => $d479263545be1416$export$5fce62f50756dbf);
$parcel$export(module.exports, "default", () => $d479263545be1416$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $a3xa0 = parcelRequire("a3xa0");
var $7TH2w = parcelRequire("7TH2w");

var $1DWH0 = parcelRequire("1DWH0");

var $2PqoT = parcelRequire("2PqoT");

var $9Gu3R = parcelRequire("9Gu3R");

var $9N1hJ = parcelRequire("9N1hJ");
const $d479263545be1416$var$DATA_PROVIDER_SUBJECT = 'atlassianSwitcherDataProvider';
var $d479263545be1416$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["LOADING"] = "loading";
    Status["COMPLETE"] = "complete";
    Status["ERROR"] = "error";
    return Status;
}({});
const $d479263545be1416$export$947ceca65da0e7a6 = (data)=>({
        status: "complete",
        data: data
    });
const $d479263545be1416$export$9569565a7ac14e8e = (result)=>result.status === "complete";
const $d479263545be1416$export$e6127cc7fe7395c3 = (result)=>result.status === "error";
const $d479263545be1416$export$20bb0d907fbbe433 = (result)=>result.status === "loading";
const $d479263545be1416$export$5fce62f50756dbf = (result)=>result.status !== "loading";
function $d479263545be1416$export$2e2bcd8739ae039(name, experienceMark, mapPropsToPromise, mapPropsToInitialValue, retryConfig, shouldUpdate) {
    const getInitialState = (props)=>{
        if (mapPropsToInitialValue) {
            const initialValue = mapPropsToInitialValue(props);
            if (initialValue !== undefined) return {
                status: "complete",
                data: initialValue
            };
        }
        return {
            status: "loading",
            data: null
        };
    };
    class DataProvider extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
        componentWillUnmount() {
            /**
       * Promise resolved after component is unmounted to be ignored
       */ this.acceptResults = false;
        }
        componentDidMount() {
            this.props.experienceTracker.markStart(experienceMark);
            this.fetchData();
        }
        componentDidUpdate(prevProps) {
            if (shouldUpdate?.(prevProps.params, this.props.params)) this.fetchData();
        }
        fetchData() {
            (0, $9Gu3R.retryOnException)(()=>mapPropsToPromise(this.props.params), {
                intervalsMS: retryConfig?.intervalsMS || [],
                shouldRetryOnException: retryConfig?.shouldRetryOnException,
                onRetry: (previousException, retryCount)=>{
                    this.onRetry(previousException, retryCount);
                }
            }).then((result)=>{
                this.onResult(result);
            }).catch((error)=>{
                this.onError(error);
            });
        }
        onResult(value) {
            if (this.acceptResults) this.setState({
                data: value,
                status: "complete"
            });
            this.props.experienceTracker.markEnd(experienceMark);
            this.fireOperationalEvent({
                action: 'receivedResult',
                actionSubjectId: name,
                attributes: {
                    provider: name
                }
            });
        }
        onRetry(error, retryCount) {
            this.fireOperationalEvent({
                action: 'retried',
                actionSubjectId: name,
                attributes: {
                    provider: name,
                    reason: retryConfig?.customErrorToReason ? retryConfig.customErrorToReason(error) : (0, $2PqoT.errorToReason)(error),
                    retryCount: retryCount
                }
            });
        }
        onError(error) {
            /**
       * Do not transition from "complete" state to "error"
       */ if (this.acceptResults && !$d479263545be1416$export$9569565a7ac14e8e(this.state)) this.setState({
                error: error,
                status: "error",
                data: null
            });
            this.fireOperationalEvent({
                action: 'failed',
                actionSubjectId: name,
                attributes: {
                    provider: name,
                    reason: (0, $2PqoT.errorToReason)(error)
                }
            });
        }
        render() {
            return this.props.children(this.state);
        }
        constructor(...args){
            super(...args);
            this.acceptResults = true;
            this.state = getInitialState(this.props.params);
            this.fireOperationalEvent = (payload)=>{
                if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                    eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                    actionSubject: $d479263545be1416$var$DATA_PROVIDER_SUBJECT,
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        outdated: !this.acceptResults
                    }
                }).fire((0, $a3xa0.NAVIGATION_CHANNEL));
            };
        }
    }
    // In prefetch, we start with empty args {}, but when getting data from the cache in the data provider, extra args are injected by HOC withAnalyticsEvents and withExperienceTracker
    // This results in a cache miss due to a key mismatch.
    // The workaround here is to use a wrapper (OuterComponent) that passes the original props as a separate prop(params) to the underlying component(InnerComponent).
    // For more info: https://product-fabric.atlassian.net/browse/CXP-2697
    DataProvider.displayName = `DataProvider(${name})`;
    const InnerComponent = (0, $1DWH0.default)()((0, $9N1hJ.withExperienceTracker)(DataProvider));
    const OuterComponent = ({ children: children, ...params })=>{
        return /*#__PURE__*/ (0, $7UHDa.jsx)(InnerComponent, {
            params: params,
            children: children
        });
    };
    return OuterComponent;
}

});
parcelRegister("a3xa0", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_CHANNEL", () => $7608769595671f03$export$515664faa1398f37);
$parcel$export(module.exports, "SWITCHER_SUBJECT", () => $7608769595671f03$export$17ff9c46e41eb585);
$parcel$export(module.exports, "SWITCHER_ITEM_SUBJECT", () => $7608769595671f03$export$7598b001981cfda5);
$parcel$export(module.exports, "SWITCHER_ITEM_LOZENGES_SUBJECT", () => $7608769595671f03$export$c3c93e13b09d3ad9);
$parcel$export(module.exports, "SWITCHER_CHILD_ITEM_SUBJECT", () => $7608769595671f03$export$7d4d527df0e3789c);
$parcel$export(module.exports, "SWITCHER_ITEM_EXPAND_SUBJECT", () => $7608769595671f03$export$16cf10618135eb24);
$parcel$export(module.exports, "SWITCHER_COMPONENT", () => $7608769595671f03$export$2b570fc112cbca);
$parcel$export(module.exports, "SWITCHER_SOURCE", () => $7608769595671f03$export$5ed36c4d23de5568);
$parcel$export(module.exports, "TRIGGER_COMPONENT", () => $7608769595671f03$export$8d2f933bbd9e4f09);
$parcel$export(module.exports, "TRIGGER_SUBJECT", () => $7608769595671f03$export$d7029a5dc66b0736);
$parcel$export(module.exports, "SWITCHER_PARTIAL_RESULTS", () => $7608769595671f03$export$4649adbfda1b6a66);
$parcel$export(module.exports, "SWITCHER_ORG_ITEM", () => $7608769595671f03$export$6dd696c9ad636a67);
$parcel$export(module.exports, "SWITCHER_ORG_NAME_EXPAND_PANEL", () => $7608769595671f03$export$53f2256589c0fa08);
$parcel$export(module.exports, "SWITCHER_CURRENT_ORG", () => $7608769595671f03$export$44c7ac3fdc1d62b8);
$parcel$export(module.exports, "SWITCHER_ORG_LIST", () => $7608769595671f03$export$d9d2f872f3b91169);
$parcel$export(module.exports, "SWITCHER_JOINABLE_SITES", () => $7608769595671f03$export$5724539c9b1a3a5d);
$parcel$export(module.exports, "SWITCHER_AVAILABLE_PRODUCTS", () => $7608769595671f03$export$22f5f827d9934254);
$parcel$export(module.exports, "createAndFireNavigationEvent", () => $7608769595671f03$export$884b1a4c7ac9dd14);
$parcel$export(module.exports, "analyticsAttributes", () => $7608769595671f03$export$a305f130b289b818);
$parcel$export(module.exports, "withAnalyticsContextData", () => $7608769595671f03$export$97ebdd8e7274f18a);
$parcel$export(module.exports, "RenderTracker", () => $7608769595671f03$export$e09ad93c2b74b853);
$parcel$export(module.exports, "NotRenderedTracker", () => $7608769595671f03$export$95b1f1a72cad0dcb);
$parcel$export(module.exports, "ViewedTracker", () => $7608769595671f03$export$b3fd6624b6a6d057);
$parcel$export(module.exports, "getJoinableSitesRenderTracker", () => $7608769595671f03$export$e823e937102b322b);
$parcel$export(module.exports, "getCustomLinksRenderTracker", () => $7608769595671f03$export$d75a4f56d85f67ea);
$parcel$export(module.exports, "getItemAnalyticsContext", () => $7608769595671f03$export$6489efba2ca85102);
$parcel$export(module.exports, "withAnalyticsEvents", () => (parcelRequire("1DWH0")).default);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => (parcelRequire("ffCOo")).NavigationAnalyticsContext);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => (parcelRequire("7TH2w")).OPERATIONAL_EVENT_TYPE);
$parcel$export(module.exports, "UI_EVENT_TYPE", () => (parcelRequire("7TH2w")).UI_EVENT_TYPE);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $ffCOo = parcelRequire("ffCOo");

var $eWRwJ = parcelRequire("eWRwJ");
var $1DWH0 = parcelRequire("1DWH0");

var $7TH2w = parcelRequire("7TH2w");

var $irYQs = parcelRequire("irYQs");

var $6jqOS = parcelRequire("6jqOS");

var $4xStv = parcelRequire("4xStv");
const $7608769595671f03$export$515664faa1398f37 = 'navigation';
const $7608769595671f03$export$17ff9c46e41eb585 = 'atlassianSwitcher';
const $7608769595671f03$export$7598b001981cfda5 = 'atlassianSwitcherItem';
const $7608769595671f03$export$c3c93e13b09d3ad9 = 'atlassianSwitcherItemLozenges';
const $7608769595671f03$export$7d4d527df0e3789c = 'atlassianSwitcherChildItem';
const $7608769595671f03$export$16cf10618135eb24 = 'atlassianSwitcherItemExpand';
const $7608769595671f03$export$2b570fc112cbca = 'atlassianSwitcher';
const $7608769595671f03$export$5ed36c4d23de5568 = 'atlassianSwitcher';
const $7608769595671f03$export$8d2f933bbd9e4f09 = 'atlassianSwitcherPrefetch';
const $7608769595671f03$export$d7029a5dc66b0736 = 'atlassianSwitcherPrefetch';
const $7608769595671f03$export$4649adbfda1b6a66 = 'atlassianSwitcherPartialResultError';
const $7608769595671f03$export$6dd696c9ad636a67 = 'atlassianSwitcherOrgItem';
const $7608769595671f03$export$53f2256589c0fa08 = 'atlassianSwitcherOrgNameExpandPanel';
const $7608769595671f03$export$44c7ac3fdc1d62b8 = 'atlassianSwitcherCurrentOrg';
const $7608769595671f03$export$d9d2f872f3b91169 = 'atlassianSwitcherOrganisationsList';
const $7608769595671f03$export$5724539c9b1a3a5d = 'atlassianSwitcherJoinableSites';
const $7608769595671f03$export$22f5f827d9934254 = 'atlassianSwitcherAvailableProducts';
const $7608769595671f03$var$SWITCHER_CUSTOM_LINKS = 'atlassianSwitcherCustomLinks';
const $7608769595671f03$var$RENDERED_ACTION = 'rendered';
const $7608769595671f03$var$NOT_RENDERED_ACTION = 'not_rendered';
const $7608769595671f03$var$VIEWED_ACTION = 'viewed';
const $7608769595671f03$export$884b1a4c7ac9dd14 = (0, $eWRwJ.default)($7608769595671f03$export$515664faa1398f37);
const $7608769595671f03$export$a305f130b289b818 = (attributes)=>({
        attributes: attributes
    });
const $7608769595671f03$export$97ebdd8e7274f18a = function(mapPropsToContext) {
    return function(WrappedComponent) {
        return (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $ffCOo.NavigationAnalyticsContext), {
                data: mapPropsToContext(props),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)(WrappedComponent, {
                    ...props
                })
            });
    };
};
const $7608769595671f03$var$isValidDuration = (duration)=>{
    return duration !== null && duration !== undefined && duration >= 0;
};
const $7608769595671f03$export$e09ad93c2b74b853 = (0, $1DWH0.default)({
    onRender: (createAnalyticsEvent, props)=>{
        const duration = props.data?.duration;
        return createAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            action: $7608769595671f03$var$RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: {
                ...props.data,
                ...$7608769595671f03$var$isValidDuration(duration) && {
                    bucket: (0, $4xStv.getMetricBucket)(duration, (0, $4xStv.RenderTrackerBuckets))
                }
            }
        }).fire($7608769595671f03$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $7608769595671f03$export$95b1f1a72cad0dcb = (0, $1DWH0.default)({
    onRender: (createAnalyticsEvent, props)=>{
        return createAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            action: $7608769595671f03$var$NOT_RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($7608769595671f03$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $7608769595671f03$export$b3fd6624b6a6d057 = (0, $1DWH0.default)({
    onRender: (createAnalyticsEvent, props)=>{
        return createAnalyticsEvent({
            eventType: (0, $7TH2w.UI_EVENT_TYPE),
            action: $7608769595671f03$var$VIEWED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($7608769595671f03$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $7608769595671f03$var$renderTrackerWithReason = ({ subject: subject, notRenderedReason: notRenderedReason, emptyRenderExpected: emptyRenderExpected, data: data })=>{
    if (notRenderedReason) return /*#__PURE__*/ (0, $7UHDa.jsx)($7608769595671f03$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: {
            ...data,
            notRenderedReason: notRenderedReason
        }
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)($7608769595671f03$export$e09ad93c2b74b853, {
        subject: subject,
        data: {
            ...data,
            emptyRender: emptyRenderExpected
        }
    });
};
const $7608769595671f03$var$renderTracker = ({ subject: subject, providerFailed: providerFailed, emptyRenderExpected: emptyRenderExpected, linksRendered: linksRendered, data: data })=>{
    if (providerFailed || linksRendered.length === 0 && !emptyRenderExpected) return /*#__PURE__*/ (0, $7UHDa.jsx)($7608769595671f03$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: {
            ...data,
            providerFailed: providerFailed
        }
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)($7608769595671f03$export$e09ad93c2b74b853, {
        subject: subject,
        data: {
            ...data,
            emptyRender: emptyRenderExpected
        }
    });
};
const $7608769595671f03$export$e823e937102b322b = (providerResult, joinableSiteLinks, data)=>{
    if (!(0, $irYQs.hasLoaded)(providerResult)) return null;
    if (providerResult.data && !providerResult.data.sites) return null;
    // The render is considered failed when either the provider failed, or the provider returned a non-empty result but nothing was rendered
    const emptyRenderExpected = Boolean(providerResult.data && providerResult.data.sites && providerResult.data.sites.length === 0);
    return $7608769595671f03$var$renderTracker({
        subject: $7608769595671f03$export$5724539c9b1a3a5d,
        providerFailed: providerResult.data === null,
        emptyRenderExpected: emptyRenderExpected,
        linksRendered: joinableSiteLinks,
        data: data
    });
};
const $7608769595671f03$export$d75a4f56d85f67ea = (customLinksProviderResult, userSiteDataProviderResult, customLinks, data)=>{
    // The render is only considered failed when one of the providers failed, and empty render is a valid case
    if (!customLinksProviderResult) return;
    const emptyRenderExpected = customLinks.length === 0;
    function getNotRenderedReason() {
        if (customLinksProviderResult?.status === (0, $irYQs.Status).ERROR) return 'custom_links_api_error';
        const error = userSiteDataProviderResult.error;
        if (!error) return null;
        if (error instanceof (0, $6jqOS.UserSiteDataError)) return error.reason;
        else return 'usd_unknown';
    }
    const notRenderedReason = getNotRenderedReason();
    return $7608769595671f03$var$renderTrackerWithReason({
        subject: $7608769595671f03$var$SWITCHER_CUSTOM_LINKS,
        notRenderedReason: notRenderedReason,
        emptyRenderExpected: emptyRenderExpected,
        data: data
    });
};
const $7608769595671f03$export$6489efba2ca85102 = (groupIndex, id, type, productType, extraAttributes)=>({
        ...$7608769595671f03$export$a305f130b289b818({
            groupIndex: groupIndex,
            itemId: id,
            itemType: type,
            productType: productType,
            ...extraAttributes
        })
    });

});
parcelRegister("6jqOS", function(module, exports) {

$parcel$export(module.exports, "UserSiteDataErrorReason", () => $06a679a5cd4d19b0$export$b08600051ba52198);
$parcel$export(module.exports, "UserSiteDataError", () => $06a679a5cd4d19b0$export$c460344055e97b1);
var $06a679a5cd4d19b0$export$b08600051ba52198 = /*#__PURE__*/ function(UserSiteDataErrorReason) {
    UserSiteDataErrorReason["APS_NO_SITE_MATCH"] = "aps_no_site_match";
    UserSiteDataErrorReason["APS_EMPTY_RESULT"] = "aps_empty_result";
    UserSiteDataErrorReason["APS_PARTIAL_EMPTY_RESULT"] = "aps_partial_response_empty_result";
    return UserSiteDataErrorReason;
}({});
class $06a679a5cd4d19b0$export$c460344055e97b1 extends Error {
    constructor(reason, message){
        super(message);
        this.reason = void 0;
        this.name = 'UserSiteDataError';
        this.reason = reason;
    }
}

});

parcelRegister("4xStv", function(module, exports) {

$parcel$export(module.exports, "RenderTrackerBuckets", () => $69527efa806e8e82$export$e59c24bc0768d568);
$parcel$export(module.exports, "getMetricBucket", () => $69527efa806e8e82$export$b59492d26971ae92);
const $69527efa806e8e82$var$INFINITY = '+Inf';
const $69527efa806e8e82$export$e59c24bc0768d568 = [
    1000,
    900,
    800,
    700,
    600,
    500
];
const $69527efa806e8e82$export$b59492d26971ae92 = (metricValue, buckets)=>{
    return metricValue >= 0 ? buckets.reduce((lowestBucket, currentBucket)=>{
        return metricValue <= currentBucket ? currentBucket.toString() : lowestBucket.toString();
    }, $69527efa806e8e82$var$INFINITY) : null;
};

});


parcelRegister("2PqoT", function(module, exports) {

$parcel$export(module.exports, "errorToReason", () => $0267a58c9e5215a2$export$a3e288208721751b);
function $0267a58c9e5215a2$export$a3e288208721751b(error) {
    const { name: name = 'Unknown', status: status } = error || {};
    return {
        name: name,
        status: status
    };
}

});

parcelRegister("9N1hJ", function(module, exports) {

$parcel$export(module.exports, "SwitcherExperienceTrackerContext", () => $83ac2687fdc1a19b$export$3f3eebb4b8116461);
$parcel$export(module.exports, "useExperienceTracker", () => $83ac2687fdc1a19b$export$cdefb2a8b53f879f);
$parcel$export(module.exports, "withExperienceTracker", () => $83ac2687fdc1a19b$export$f88dde183f4d31cb);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $83ac2687fdc1a19b$var$noop = ()=>{};
const $83ac2687fdc1a19b$export$3f3eebb4b8116461 = /*#__PURE__*/ (0, $gwFzn.createContext)({
    start: $83ac2687fdc1a19b$var$noop,
    success: $83ac2687fdc1a19b$var$noop,
    failure: $83ac2687fdc1a19b$var$noop,
    failureAll: $83ac2687fdc1a19b$var$noop,
    abort: $83ac2687fdc1a19b$var$noop,
    abortAll: $83ac2687fdc1a19b$var$noop,
    markStart: $83ac2687fdc1a19b$var$noop,
    markEnd: $83ac2687fdc1a19b$var$noop
});
const $83ac2687fdc1a19b$export$cdefb2a8b53f879f = ()=>(0, $gwFzn.useContext)($83ac2687fdc1a19b$export$3f3eebb4b8116461);
const $83ac2687fdc1a19b$export$f88dde183f4d31cb = (Component)=>{
    const WithExperienceTracker = (props)=>{
        const experienceTracker = $83ac2687fdc1a19b$export$cdefb2a8b53f879f();
        return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
            ...props,
            experienceTracker: experienceTracker
        });
    };
    WithExperienceTracker.displayName = `WithExperienceTracker(${Component.displayName})`;
    return WithExperienceTracker;
};

});


parcelRegister("dcO0p", function(module, exports) {

$parcel$export(module.exports, "Permissions", () => $f5ec26d9e36da60c$export$2d41982586bbb6be);
$parcel$export(module.exports, "Product", () => $f5ec26d9e36da60c$export$264ad599d7cef668);
$parcel$export(module.exports, "Feature", () => $f5ec26d9e36da60c$export$6e91cf7616333d5);
$parcel$export(module.exports, "AnalyticsItemType", () => $f5ec26d9e36da60c$export$77f267162e8983fb);
$parcel$export(module.exports, "ProductKey", () => $f5ec26d9e36da60c$export$f3a53bd43617a593);
var $f5ec26d9e36da60c$export$2d41982586bbb6be = /*#__PURE__*/ function(Permissions) {
    Permissions["MANAGE"] = "manage";
    Permissions["CAN_INVITE_USERS"] = "invite-users";
    return Permissions;
}({});
var $f5ec26d9e36da60c$export$264ad599d7cef668 = /*#__PURE__*/ function(Product) {
    Product["BITBUCKET"] = "bitbucket";
    Product["CONFLUENCE"] = "confluence";
    Product["HOME"] = "home";
    Product["JIRA"] = "jira";
    Product["SITE_ADMIN"] = "site-admin";
    Product["TRELLO"] = "trello";
    Product["START"] = "start";
    return Product;
}({});
var $f5ec26d9e36da60c$export$6e91cf7616333d5 = /*#__PURE__*/ function(Feature) {
    Feature["isUFOEnabled"] = "isUFOEnabled";
    return Feature;
}({});
var $f5ec26d9e36da60c$export$77f267162e8983fb = /*#__PURE__*/ function(AnalyticsItemType) {
    AnalyticsItemType["PRODUCT"] = "product";
    AnalyticsItemType["ADMIN"] = "admin";
    AnalyticsItemType["TRY"] = "try";
    AnalyticsItemType["JOIN"] = "join";
    AnalyticsItemType["CUSTOM_LINK"] = "customLink";
    AnalyticsItemType["EMPTY_STATE_EXPLORE_PRODUCTS"] = "empty-state-explore-products";
    return AnalyticsItemType;
}({});
var $f5ec26d9e36da60c$export$f3a53bd43617a593 = /*#__PURE__*/ function(ProductKey) {
    ProductKey["CONFLUENCE"] = "confluence.ondemand";
    ProductKey["JIRA_CORE"] = "jira-core.ondemand";
    ProductKey["JIRA_SOFTWARE"] = "jira-software.ondemand";
    ProductKey["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    ProductKey["BITBUCKET"] = "bitbucket";
    ProductKey["OPSGENIE"] = "opsgenie";
    ProductKey["STATUSPAGE"] = "statuspage";
    ProductKey["TRELLO"] = "trello";
    ProductKey["COMPASS"] = "compass";
    ProductKey["TEAM_CENTRAL"] = "townsquare";
    ProductKey["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
    return ProductKey;
}({});

});

parcelRegister("bgtNw", function(module, exports) {

$parcel$export(module.exports, "withCached", () => $952e82f27780b933$export$7f51828d6b6af163);
const $952e82f27780b933$export$d4d4b402ab64e2f4 = 5000;
const $952e82f27780b933$var$isPromise = (p)=>{
    return typeof p.then === 'function' && typeof p.catch === 'function';
};
const $952e82f27780b933$export$7f51828d6b6af163 = (fn)=>{
    const resultCache = new Map();
    const promiseCache = new Map();
    function getCacheKey(...args) {
        return JSON.stringify(args);
    }
    const cached = (...args)=>{
        const cacheKey = getCacheKey(...args);
        return resultCache.get(cacheKey);
    };
    const reset = ()=>{
        resultCache.clear();
        promiseCache.clear();
    };
    const execute = (...args)=>{
        const cacheKey = getCacheKey(...args);
        const cachedPromise = promiseCache.get(cacheKey);
        if (cachedPromise !== undefined) return cachedPromise;
        const maybePromise = fn(...args);
        promiseCache.set(cacheKey, maybePromise);
        if ($952e82f27780b933$var$isPromise(maybePromise)) maybePromise.then((result)=>{
            resultCache.set(cacheKey, result);
            setTimeout(()=>promiseCache.delete(cacheKey), $952e82f27780b933$export$d4d4b402ab64e2f4);
        }).catch(()=>{
            promiseCache.delete(cacheKey);
        });
        return maybePromise;
    };
    return Object.assign(execute, fn, {
        cached: cached,
        reset: reset
    });
};

});

parcelRegister("grirN", function(module, exports) {

$parcel$export(module.exports, "Experience", () => $8a33a59a55c04de9$export$c90b54e658fc4d7c);
$parcel$export(module.exports, "EXPERIENCE_CONFIGS", () => $8a33a59a55c04de9$export$d54d7a2744fdf647);
$parcel$export(module.exports, "ExperienceMark", () => $8a33a59a55c04de9$export$cbf1e672c3e37474);
$parcel$export(module.exports, "EXPERIENCES_TO_MARKS", () => $8a33a59a55c04de9$export$755e75afbd377bc4);
$parcel$export(module.exports, "MARKS_TO_EXPERIENCES", () => $8a33a59a55c04de9$export$805ed806e0769ee4);
$parcel$export(module.exports, "ExperienceMarkPhase", () => $8a33a59a55c04de9$export$ec8391a70bbdbe59);
$parcel$export(module.exports, "AbortReason", () => $8a33a59a55c04de9$export$279d6315a97b520d);
$parcel$export(module.exports, "SWITCHER_RENDER_START_PERFORMANCE_MARK", () => $8a33a59a55c04de9$export$86919b84f9a64054);

var $9NDUe = parcelRequire("9NDUe");

var $9W9Dk = parcelRequire("9W9Dk");
var $8a33a59a55c04de9$export$c90b54e658fc4d7c = /*#__PURE__*/ function(Experience) {
    Experience["RENDER_CUSTOM_LINKS_SECTION"] = "render-custom-links-section";
    Experience["RENDER_JOIN_SECTION"] = "render-join-section";
    Experience["RENDER_SWITCH_TO_SECTION"] = "render-switch-to-section";
    Experience["RENDER_SWITCHER_EMPTY_STATE"] = "render-switcher-empty-state";
    return Experience;
}({});
const $8a33a59a55c04de9$export$d54d7a2744fdf647 = {
    ["render-custom-links-section"]: {
        type: (0, $9NDUe.ExperienceTypes).Load,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-join-section"]: {
        type: (0, $9NDUe.ExperienceTypes).Load,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-switch-to-section"]: {
        type: (0, $9NDUe.ExperienceTypes).Load,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-switcher-empty-state"]: {
        type: (0, $9NDUe.ExperienceTypes).Load,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad
    }
};
var $8a33a59a55c04de9$export$cbf1e672c3e37474 = /*#__PURE__*/ function(ExperienceMark) {
    ExperienceMark["API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS"] = "api-app-switcher-bff-available-products";
    ExperienceMark["API_CONFLUENCE_CUSTOM_LINKS"] = "api-confluence-custom-links";
    ExperienceMark["API_FLIGHT_DECK"] = "api-flight-deck";
    ExperienceMark["API_JIRA_CUSTOM_LINKS"] = "api-jira-custom-links";
    ExperienceMark["API_JOINABLE_SITES"] = "api-joinable-sites";
    ExperienceMark["API_PERMISSIONS"] = "api-permissions";
    ExperienceMark["SWITCHER_INITIAL_MOUNT"] = "switcher-initial-mount";
    ExperienceMark["SWITCHER_SKELETON_MOUNT"] = "switcher-skeleton-mount";
    // Mock for tests
    ExperienceMark["TEST_MARK"] = "test-mark";
    return ExperienceMark;
}({});
const $8a33a59a55c04de9$var$allNonTestExperienceMarks = Object.values($8a33a59a55c04de9$export$cbf1e672c3e37474).filter((mark)=>mark !== "test-mark");
const $8a33a59a55c04de9$export$755e75afbd377bc4 = {
    ["render-custom-links-section"]: $8a33a59a55c04de9$var$allNonTestExperienceMarks,
    ["render-join-section"]: $8a33a59a55c04de9$var$allNonTestExperienceMarks,
    ["render-switch-to-section"]: $8a33a59a55c04de9$var$allNonTestExperienceMarks,
    ["render-switcher-empty-state"]: $8a33a59a55c04de9$var$allNonTestExperienceMarks
};
const $8a33a59a55c04de9$export$805ed806e0769ee4 = (0, $9W9Dk.invertRecordOfArrays)($8a33a59a55c04de9$export$755e75afbd377bc4);
var $8a33a59a55c04de9$export$ec8391a70bbdbe59 = /*#__PURE__*/ function(ExperienceMarkPhase) {
    ExperienceMarkPhase["START"] = "start";
    ExperienceMarkPhase["END"] = "end";
    return ExperienceMarkPhase;
}({});
var $8a33a59a55c04de9$export$279d6315a97b520d = /*#__PURE__*/ function(AbortReason) {
    AbortReason["COMPONENT_UNMOUNTED"] = "component-unmounted";
    AbortReason["WINDOW_UNLOADING"] = "window-unloading";
    return AbortReason;
}({});
const $8a33a59a55c04de9$export$86919b84f9a64054 = 'atlassianSwitcher.render.start';

});
parcelRegister("9W9Dk", function(module, exports) {

$parcel$export(module.exports, "invertRecordOfArrays", () => $e9039098110424ea$export$c371a74fe5222b3);
function $e9039098110424ea$export$c371a74fe5222b3(record) {
    const invertedRecord = {};
    Object.entries(record).forEach(([key, values])=>{
        values.forEach((value)=>{
            if (!invertedRecord[value]) invertedRecord[value] = [];
            invertedRecord[value].push(key);
        });
    });
    return invertedRecord;
}

});


parcelRegister("cj14x", function(module, exports) {

$parcel$export(module.exports, "createProviderWithCustomFetchData", () => $0acabe6f2babf099$export$310e48be95687c2f);

var $irYQs = parcelRequire("irYQs");

var $kBWmB = parcelRequire("kBWmB");

var $bgtNw = parcelRequire("bgtNw");
const $0acabe6f2babf099$export$500fbc0cd14cdbaa = (name, experienceMark, url)=>{
    const fetchMethod = (0, $bgtNw.withCached)((param)=>(0, $kBWmB.fetchJson)(url));
    return {
        fetchMethod: fetchMethod,
        ProviderComponent: (0, $irYQs.default)(name, experienceMark, fetchMethod, fetchMethod.cached, // fetch will only throw on a network exception,
        // so we can safely retry on all exceptions
        {
            shouldRetryOnException: ()=>true,
            intervalsMS: [
                50,
                200,
                1000
            ]
        })
    };
};
const $0acabe6f2babf099$export$310e48be95687c2f = (name, experienceMark, fetchData, retryConfig)=>{
    const fetchMethod = (0, $bgtNw.withCached)((param)=>fetchData(param));
    return {
        fetchMethod: fetchMethod,
        ProviderComponent: (0, $irYQs.default)(name, experienceMark, fetchMethod, fetchMethod.cached, retryConfig)
    };
};

});

parcelRegister("emHKt", function(module, exports) {

$parcel$export(module.exports, "createJoinableSitesProvider", () => $e2ed5e516e933600$export$c3b6af53f1ca17d8);

var $cj14x = parcelRequire("cj14x");

var $grirN = parcelRequire("grirN");
const $e2ed5e516e933600$export$62986affcccd56a5 = ()=>Promise.resolve({
        sites: undefined
    });
const $e2ed5e516e933600$export$c3b6af53f1ca17d8 = (fetchData = $e2ed5e516e933600$export$62986affcccd56a5, retryConfig)=>{
    return (0, $cj14x.createProviderWithCustomFetchData)('joinableSites', (0, $grirN.ExperienceMark).API_JOINABLE_SITES, fetchData, retryConfig);
};

});

parcelRegister("2uNd6", function(module, exports) {

$parcel$export(module.exports, "loadAtlassianSwitcher", () => $43492e8623899440$export$6c6894dd831bfacb);
$parcel$export(module.exports, "loadJiraSwitcher", () => $43492e8623899440$export$52c59c5b477673fb);
$parcel$export(module.exports, "loadConfluenceSwitcher", () => $43492e8623899440$export$2d2945898d9ee55f);
$parcel$export(module.exports, "loadGenericSwitcher", () => $43492e8623899440$export$64191a36345a6b2b);
$parcel$export(module.exports, "AtlassianSwitcherLoader", () => $43492e8623899440$export$25f16f9fee84a840);
$parcel$export(module.exports, "JiraSwitcherLoader", () => $43492e8623899440$export$10767845f9f42bd);
$parcel$export(module.exports, "ConfluenceSwitcherLoader", () => $43492e8623899440$export$71f961c620294b68);
$parcel$export(module.exports, "GenericSwitcherLoader", () => $43492e8623899440$export$8c21d1a0c59fc17e);

var $7UHDa = parcelRequire("7UHDa");

var $4wH3g = parcelRequire("4wH3g");
parcelRequire("gwFzn");

var $hRQgD = parcelRequire("hRQgD");

const $43492e8623899440$export$6c6894dd831bfacb = ()=>(parcelRequire("jgn9E")).then((module)=>module.default);

const $43492e8623899440$export$52c59c5b477673fb = ()=>(parcelRequire("2nZgg")).then((module)=>module.default);

const $43492e8623899440$export$2d2945898d9ee55f = ()=>(parcelRequire("j27Sd")).then((module)=>module.default);

const $43492e8623899440$export$64191a36345a6b2b = ()=>(parcelRequire("2tou7")).then((module)=>module.default);
const $43492e8623899440$export$25f16f9fee84a840 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "SZcx1",
    name: "AtlassianSwitcherLoader",
    loader: $43492e8623899440$export$6c6894dd831bfacb,
    loading: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $hRQgD.default), {})
});
const $43492e8623899440$export$10767845f9f42bd = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "HbcUy",
    name: "JiraSwitcherLoader",
    loader: $43492e8623899440$export$52c59c5b477673fb,
    loading: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $hRQgD.default), {})
});
const $43492e8623899440$export$71f961c620294b68 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "IdoNX",
    name: "ConfluenceSwitcherLoader",
    loader: $43492e8623899440$export$2d2945898d9ee55f,
    loading: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $hRQgD.default), {})
});
const $43492e8623899440$export$8c21d1a0c59fc17e = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "xoErk",
    name: "GenericSwitcherLoader",
    loader: $43492e8623899440$export$64191a36345a6b2b,
    loading: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $hRQgD.default), {})
});

});
parcelRegister("hRQgD", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a02204e74f72794$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $6fnsQ = parcelRequire("6fnsQ");

var $fJvXe = parcelRequire("fJvXe");

var $lYygP = parcelRequire("lYygP");

var $grirN = parcelRequire("grirN");
var $88ga6 = parcelRequire("88ga6");

var $dBxQj = parcelRequire("dBxQj");

var $d3Dtl = parcelRequire("d3Dtl");
const $6a02204e74f72794$var$iconSkeletonStyles = (0, $3jLHL.css)({
    display: 'inline-block',
    width: 32,
    height: 32,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: `var(--ds-skeleton, ${$6fnsQ.N20})`,
    borderRadius: "var(--ds-border-radius-200, 8px)"
});
const $6a02204e74f72794$var$lineSkeletonStyles = (0, $3jLHL.css)({
    display: 'inline-block',
    width: 98,
    height: 10,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: `var(--ds-skeleton, ${$6fnsQ.N20})`,
    borderRadius: "var(--ds-border-radius, 3px)"
});
const $6a02204e74f72794$var$iconSkeleton = /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
    css: $6a02204e74f72794$var$iconSkeletonStyles
});
const $6a02204e74f72794$var$lineSkeleton = /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
    css: $6a02204e74f72794$var$lineSkeletonStyles
});
var $6a02204e74f72794$export$2e2bcd8739ae039 = ()=>{
    (0, $88ga6.useExperienceRenderAndMountMark)((0, $grirN.ExperienceMark).SWITCHER_SKELETON_MOUNT);
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $fJvXe.SectionContainer), {
        sectionId: "skeleton",
        title: $6a02204e74f72794$var$lineSkeleton,
        sectionRole: "alert",
        "aria-label": formatMessage((0, $d3Dtl.default).skeletonLoaderAriaLabel)
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $lYygP.default), {
        tag: "li",
        icon: $6a02204e74f72794$var$iconSkeleton,
        isDisabled: true,
        "aria-hidden": "true"
    }, $6a02204e74f72794$var$lineSkeleton), /*#__PURE__*/ (0, $3jLHL.jsx)((0, $lYygP.default), {
        tag: "li",
        icon: $6a02204e74f72794$var$iconSkeleton,
        isDisabled: true,
        "aria-hidden": "true"
    }, $6a02204e74f72794$var$lineSkeleton), /*#__PURE__*/ (0, $3jLHL.jsx)((0, $lYygP.default), {
        tag: "li",
        icon: $6a02204e74f72794$var$iconSkeleton,
        isDisabled: true,
        "aria-hidden": "true"
    }, $6a02204e74f72794$var$lineSkeleton));
};

});
parcelRegister("fJvXe", function(module, exports) {

$parcel$export(module.exports, "SectionContainer", () => $1407d3a7b9c1a0d6$export$be4c8679ebfd988);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable */ 
var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $bP2lm = parcelRequire("bP2lm");

var $3jLHL = parcelRequire("3jLHL");

var $a3xa0 = parcelRequire("a3xa0");
var $ffCOo = parcelRequire("ffCOo");

var $hhh77 = parcelRequire("hhh77");

var $eCKH3 = parcelRequire("eCKH3");

var $dcO0p = parcelRequire("dcO0p");

var $7hXDW = parcelRequire("7hXDW");

var $eycgM = parcelRequire("eycgM");
const $1407d3a7b9c1a0d6$var$baseSectionContainerStyles = (0, $3jLHL.css)({
    padding: `${"var(--ds-space-075, 6px)"} 0`
});
const $1407d3a7b9c1a0d6$var$visualRefreshStyles = (0, $3jLHL.css)({
    paddingTop: "var(--ds-space-100, 8px)",
    overflow: 'hidden',
    marginTop: '-1px',
    borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`
});
const $1407d3a7b9c1a0d6$var$boxStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.100',
    marginRight: 'space.100',
    marginTop: '0',
    marginBottom: 'space.100'
});
const $1407d3a7b9c1a0d6$var$secondarySectionTitleBaseStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    marginTop: 'space.200',
    marginLeft: 'space.100',
    color: 'color.text.subtle',
    font: 'font.body.small',
    fontWeight: 'font.weight.bold',
    marginBottom: 'space.050'
});
const $1407d3a7b9c1a0d6$var$refreshedSecondarySectionTitleBaseStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.075',
    marginLeft: 'space.100',
    marginBottom: 'space.075',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: 'color.text.subtlest',
    fontWeight: 'font.weight.medium'
});
const $1407d3a7b9c1a0d6$var$sectionChildrenWrapperStyles = (0, $3jLHL.css)({
    listStyleType: 'none',
    padding: 0,
    margin: 0
});
const $1407d3a7b9c1a0d6$export$7bb82566a1f2a4f5 = ({ title: title })=>{
    const isVisualRefreshEnabled = (0, $eycgM.useIsSwitcherTeam25TestCohort)();
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $7hXDW.default), {
        as: "h2",
        size: "xxsmall"
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
        xcss: isVisualRefreshEnabled ? $1407d3a7b9c1a0d6$var$refreshedSecondarySectionTitleBaseStyles : $1407d3a7b9c1a0d6$var$secondarySectionTitleBaseStyles
    }, title));
};
const $1407d3a7b9c1a0d6$var$SectionContainerComponent = ({ title: title, titleLink: titleLink, children: children, actionSubject: actionSubject, sectionId: sectionId, sectionRole: sectionRole, ariaLabel: ariaLabel })=>{
    const isVisualRefreshEnabled = (0, $eycgM.useIsSwitcherTeam25TestCohort)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.toArray(children).some(Boolean) ? /*#__PURE__*/ (0, $3jLHL.jsx)("section", {
        css: isVisualRefreshEnabled ? $1407d3a7b9c1a0d6$var$visualRefreshStyles : $1407d3a7b9c1a0d6$var$baseSectionContainerStyles,
        "data-testid": `${sectionId}__section`,
        role: sectionRole,
        "aria-label": ariaLabel
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
        xcss: isVisualRefreshEnabled ? $1407d3a7b9c1a0d6$var$boxStyles : undefined
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $hhh77.FadeIn), null, title && /*#__PURE__*/ (0, $3jLHL.jsx)($1407d3a7b9c1a0d6$export$7bb82566a1f2a4f5, {
        title: title
    }), titleLink && /*#__PURE__*/ (0, $3jLHL.jsx)($1407d3a7b9c1a0d6$var$TitleLink, {
        titleLink: titleLink,
        actionSubject: actionSubject
    })), /*#__PURE__*/ (0, $3jLHL.jsx)("ul", {
        css: $1407d3a7b9c1a0d6$var$sectionChildrenWrapperStyles
    }, children))) : null;
};
const $1407d3a7b9c1a0d6$var$TitleLink = ({ titleLink: titleLink, actionSubject: actionSubject })=>/*#__PURE__*/ (0, $3jLHL.jsx)((0, $ffCOo.NavigationAnalyticsContext), {
        key: titleLink.key,
        data: (0, $a3xa0.getItemAnalyticsContext)(0, titleLink.key, (0, $dcO0p.AnalyticsItemType).PRODUCT, titleLink.productType)
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $eCKH3.default), {
        href: titleLink.href,
        iconAfter: /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bP2lm))), {
            LEGACY_size: "small",
            color: "currentColor",
            label: ""
        }),
        label: titleLink.label,
        testId: "section-title__link",
        actionSubject: actionSubject,
        ariaLabel: titleLink.ariaLabel
    }));
const $1407d3a7b9c1a0d6$export$be4c8679ebfd988 = (0, $a3xa0.withAnalyticsContextData)((props)=>(0, $a3xa0.analyticsAttributes)({
        group: props.sectionId,
        groupItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.toArray(props.children).filter((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(child)).length
    }))($1407d3a7b9c1a0d6$var$SectionContainerComponent); /* eslint-enable */ 

});
parcelRegister("hhh77", function(module, exports) {

$parcel$export(module.exports, "FadeIn", () => $84079bfb5c128ee4$export$bd7370ffb2917ab7);
/* fade-in.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");
parcelRequire("gwFzn");
const $84079bfb5c128ee4$var$fadeIn = null;
const $84079bfb5c128ee4$var$fadeInStyles = null;
const $84079bfb5c128ee4$export$bd7370ffb2917ab7 = ({ children: children, className: className, tag: Tag = 'div' })=>/*#__PURE__*/ (0, $7UHDa.jsx)(Tag, {
        className: (0, $35pXk.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _j7hq16na _5sag1bs3 _1pgl5ucs _1o51q7pw _tzy4idpf _syaz1fxt",
            className
        ]),
        children: children
    });

});

parcelRegister("eCKH3", function(module, exports) {

$parcel$export(module.exports, "default", () => $c38c91c3d8ce7826$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $eEA8O = parcelRequire("eEA8O");

var $bP2lm = parcelRequire("bP2lm");

var $1DWH0 = parcelRequire("1DWH0");

var $7TH2w = parcelRequire("7TH2w");

var $a3xa0 = parcelRequire("a3xa0");

var $4jR19 = parcelRequire("4jR19");
const $c38c91c3d8ce7826$var$ItemLink = ({ label: label, href: href, testId: testId, onClick: onClick, ariaLabel: ariaLabel })=>{
    const buttonProps = {
        appearance: 'link',
        href: href,
        className: 'section-link',
        target: '_blank',
        rel: 'noopener noreferrer',
        iconAfter: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bP2lm))), {
            LEGACY_size: "small",
            color: "currentColor",
            label: ""
        }),
        onClick: onClick ? (e, a)=>onClick(e, a) : undefined,
        testId: testId
    };
    if (ariaLabel) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        ...ariaLabel,
        children: (placeholder)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEA8O.default), {
                ...buttonProps,
                "aria-label": String(placeholder),
                children: label
            })
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEA8O.default), {
        ...buttonProps,
        children: label
    });
};
var $c38c91c3d8ce7826$export$2e2bcd8739ae039 = (0, $1DWH0.default)({
    onClick: (0, $a3xa0.createAndFireNavigationEvent)({
        eventType: (0, $7TH2w.UI_EVENT_TYPE),
        action: 'clicked',
        actionSubject: (0, $a3xa0.SWITCHER_ITEM_SUBJECT)
    })
})($c38c91c3d8ce7826$var$ItemLink);

});

parcelRegister("eycgM", function(module, exports) {

$parcel$export(module.exports, "SwitcherExperimentProvider", () => $de14f99adc16bc86$export$cd11e4cf103a20cf);
$parcel$export(module.exports, "useSwitcherTeam25Experiment", () => $de14f99adc16bc86$export$f0a8b7930250858a);
$parcel$export(module.exports, "useIsSwitcherTeam25TestCohort", () => $de14f99adc16bc86$export$3b522177296bf82b);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
// Temporary fix to enable the Growth team’s app recommendation section to access our experiment.
// TODO: https://hello.jira.atlassian.cloud/browse/NAVX-350
const $de14f99adc16bc86$var$storageKey = '@atlassian/switcher-team-25-experiment-cohort';
const $de14f99adc16bc86$export$fcdf652c4fd8e4c7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext(undefined);
const $de14f99adc16bc86$export$cd11e4cf103a20cf = ({ children: children })=>{
    const [switcherTeam25ExperimentCohort, setSwitcherTeam25ExperimentCohort] = (0, $gwFzn.useState)();
    const contextValue = (0, $gwFzn.useMemo)(()=>({
            switcherTeam25ExperimentCohort: switcherTeam25ExperimentCohort,
            setSwitcherTeam25ExperimentCohort: setSwitcherTeam25ExperimentCohort
        }), [
        switcherTeam25ExperimentCohort,
        setSwitcherTeam25ExperimentCohort
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (window?.sessionStorage && switcherTeam25ExperimentCohort) window.sessionStorage.setItem($de14f99adc16bc86$var$storageKey, switcherTeam25ExperimentCohort);
    }, [
        switcherTeam25ExperimentCohort
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($de14f99adc16bc86$export$fcdf652c4fd8e4c7.Provider, {
        value: contextValue,
        children: children
    });
};
const $de14f99adc16bc86$export$3135e38521020087 = ()=>(0, $gwFzn.useContext)($de14f99adc16bc86$export$fcdf652c4fd8e4c7);
const $de14f99adc16bc86$export$f0a8b7930250858a = ()=>{
    const experimentContext = $de14f99adc16bc86$export$3135e38521020087();
    return {
        cohort: experimentContext?.switcherTeam25ExperimentCohort,
        setCohort: experimentContext ? experimentContext.setSwitcherTeam25ExperimentCohort : ()=>{}
    };
};
const $de14f99adc16bc86$export$3b522177296bf82b = ()=>{
    const { cohort: cohort } = $de14f99adc16bc86$export$f0a8b7930250858a();
    if (cohort) return cohort === 'test';
    // fallback to session storage
    return window?.sessionStorage?.getItem($de14f99adc16bc86$var$storageKey) === 'test';
};

});


parcelRegister("lYygP", function(module, exports) {

$parcel$export(module.exports, "LozengeType", () => $53dd823c995635cb$export$b95b532653e2b7f6);
$parcel$export(module.exports, "default", () => $53dd823c995635cb$export$2e2bcd8739ae039);
/* item.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $cGtPE = parcelRequire("cGtPE");

var $a3xa0 = parcelRequire("a3xa0");

var $hhh77 = parcelRequire("hhh77");

var $aIk0I = parcelRequire("aIk0I");

var $4jR19 = parcelRequire("4jR19");

var $d3Dtl = parcelRequire("d3Dtl");

var $f8Iqd = parcelRequire("f8Iqd");
var $53dd823c995635cb$export$b95b532653e2b7f6 = /*#__PURE__*/ function(LozengeType) {
    LozengeType["New"] = "new";
    LozengeType["Try"] = "try";
    return LozengeType;
}({});
const $53dd823c995635cb$var$lozengeData = {
    ["new"]: {
        label: (0, $d3Dtl.default).newLozenge,
        componentProps: {
            appearance: 'new'
        }
    },
    ["try"]: {
        label: (0, $d3Dtl.default).tryLozenge,
        componentProps: {
            appearance: 'new'
        }
    }
};
const $53dd823c995635cb$var$fadeInStyles = null;
const $53dd823c995635cb$var$itemDescriptionStyles = null;
const $53dd823c995635cb$var$titleWrapper = null;
const $53dd823c995635cb$var$hasDescriptionStyles = null;
const $53dd823c995635cb$var$SwitcherItem = ({ icon: icon, description: description, elemAfter: elemAfter, shouldAllowMultiline: shouldAllowMultiline, onClick: onClick, children: children, lozenges: lozenges, product: product, createAnalyticsEvent: createAnalyticsEvent, tag: tag, href: href, ...rest })=>{
    const itemDescription = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useMemo(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(description) || typeof description === 'string') return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
            className: (0, $35pXk.default)([
                "_1reo15vq _18m915vq _1e0c1ule _2hwxxy5q _1bto1l2s"
            ]),
            children: description
        });
        return undefined;
    }, [
        description
    ]);
    const renderLozenges = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useMemo(()=>{
        if (!lozenges?.length) return null;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $f8Iqd.default), {
            product: product,
            triggerSubject: "switcherItemLozengeErrorBoundary",
            hideFallbackUI: true,
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    lozenges.map((lozenge, index)=>{
                        const { componentProps: componentProps, label: label } = $53dd823c995635cb$var$lozengeData[lozenge];
                        return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                            style: {
                                marginLeft: "var(--ds-space-100, 8px)"
                            },
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aIk0I.default), {
                                ...componentProps,
                                testId: "switcher-item-lozenge",
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                                    ...label
                                })
                            })
                        }, index);
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a3xa0.RenderTracker), {
                        subject: (0, $a3xa0.SWITCHER_ITEM_LOZENGES_SUBJECT),
                        data: {
                            product: product,
                            lozenges: lozenges,
                            children: children,
                            description: description
                        }
                    })
                ]
            })
        });
    }, [
        lozenges,
        product,
        children,
        description
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hhh77.FadeIn), {
        tag: tag,
        className: (0, $35pXk.default)([
            "_1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cGtPE.default), {
            testId: "switcher-base-item",
            description: itemDescription,
            iconBefore: icon,
            shouldTitleWrap: false,
            shouldDescriptionWrap: false,
            iconAfter: elemAfter,
            target: "_blank",
            href: href ?? '#',
            onClick: (event)=>{
                // To prevent the page from reloading when using a fallback '#' in href, make sure to use preventDefault.
                if (!href) event.preventDefault();
                if (onClick) onClick(event);
            },
            ...rest,
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)("span", {
                className: (0, $35pXk.default)([
                    "_1e0c1ule",
                    itemDescription && "_19pk1i6y"
                ]),
                children: [
                    children,
                    renderLozenges
                ]
            })
        })
    });
};
var $53dd823c995635cb$export$2e2bcd8739ae039 = $53dd823c995635cb$var$SwitcherItem;

});
parcelRegister("d3Dtl", function(module, exports) {

$parcel$export(module.exports, "default", () => $baba7124b42cf074$export$2e2bcd8739ae039);

var $2nPZH = parcelRequire("2nPZH");
const $baba7124b42cf074$var$messages = (0, $2nPZH.defineMessages)({
    newLozenge: {
        id: "fabric.atlassianSwitcher.newLozenge",
        defaultMessage: "New"
    },
    tryLozenge: {
        id: "fabric.atlassianSwitcher.tryLozenge",
        defaultMessage: "Try"
    },
    sites: {
        id: "fabric.atlassianSwitcher.sites",
        defaultMessage: "{productName} {numSites, plural, one {site} other {sites}}"
    },
    skeletonLoaderAriaLabel: {
        id: "fabric.atlassianSwitcher.skeletonLoaderAriaLabel",
        defaultMessage: "The App Switcher is loading"
    }
});
var $baba7124b42cf074$export$2e2bcd8739ae039 = $baba7124b42cf074$var$messages;

});

parcelRegister("f8Iqd", function(module, exports) {

$parcel$export(module.exports, "default", () => $182fb7a040953fe9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /** @jsxFrag */ 
var $6f0Oj = parcelRequire("6f0Oj");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $7hXDW = parcelRequire("7hXDW");

var $ccHMk = parcelRequire("ccHMk");
var $7p4As = parcelRequire("7p4As");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $js7oX = parcelRequire("js7oX");

var $3jLHL = parcelRequire("3jLHL");

var $gjGxN = parcelRequire("gjGxN");

var $kyZGY = parcelRequire("kyZGY");

var $a3xa0 = parcelRequire("a3xa0");
var $7TH2w = parcelRequire("7TH2w");
var $1DWH0 = parcelRequire("1DWH0");

var $h2l3D = parcelRequire("h2l3D");

var $2PqoT = parcelRequire("2PqoT");

var $kaECR = parcelRequire("kaECR");

var $dcO0p = parcelRequire("dcO0p");

var $iFil1 = parcelRequire("iFil1");

var $jIyl9 = parcelRequire("jIyl9");
const $182fb7a040953fe9$var$TRIGGER_SUBJECT = 'errorBoundary';
const $182fb7a040953fe9$var$ACTION_SUBJECT = 'rendered';
// This image is also used as the generic error message in Notifications
const $182fb7a040953fe9$var$robotsImgStyles = (0, $3jLHL.css)({
    height: 200
});
const $182fb7a040953fe9$var$trelloErrorImgStyles = (0, $3jLHL.css)({
    width: 140,
    height: 88
});
const $182fb7a040953fe9$var$unverifiedUserImageStyles = (0, $3jLHL.css)({
    height: 150
});
const $182fb7a040953fe9$var$errorContentStyles = (0, $3jLHL.css)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
});
const $182fb7a040953fe9$var$errorHeadingStyles = (0, $ecnYn.xcss)({
    maxWidth: '240',
    marginTop: 'space.400'
});
const $182fb7a040953fe9$var$errorMessageStyles = (0, $ecnYn.xcss)({
    maxWidth: '240',
    marginTop: 'space.300'
});
const $182fb7a040953fe9$var$errorBoundaryBoxStyles = (0, $3jLHL.css)({
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center',
    margin: `${"var(--ds-space-600, 48px)"} 0`
});
const $182fb7a040953fe9$var$loginButtonStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.300',
    justifyContent: 'center',
    alignSelf: 'stretch'
});
const $182fb7a040953fe9$var$ErrorMessage = (props)=>/*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
        xcss: $182fb7a040953fe9$var$errorMessageStyles
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $5dK2X.default), {
        as: "p"
    }, props.children));
class $182fb7a040953fe9$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    componentDidCatch(error) {
        const reason = error instanceof (0, $iFil1.SwitcherLoadError) ? error.reason() : (0, $2PqoT.errorToReason)(error);
        this.setState({
            hasError: true,
            reason: reason
        }, ()=>{
            this.fireOperationalEvent({
                action: $182fb7a040953fe9$var$ACTION_SUBJECT,
                attributes: {
                    ...reason,
                    ...this.props.extraAnalyticProps
                }
            });
        });
        this.props.onErrorCallback?.(error);
    }
    renderErrorBody() {
        const { reason: reason } = this.state;
        if (!reason) return;
        if (reason.name === (0, $jIyl9.FETCH_ERROR_NAME)) {
            const isTrello = this.props.product === (0, $dcO0p.Product).TRELLO;
            if (reason.status === 401) // Not authorised http error
            return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, $3jLHL.jsx)($182fb7a040953fe9$var$ErrorMessage, null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4jR19.default), (0, $kaECR.default).errorTextLoggedOut)), isTrello ? /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                xcss: $182fb7a040953fe9$var$loginButtonStyles
            }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $7p4As.default), {
                href: (0, $h2l3D.getLoginUrl)((0, $dcO0p.Product).TRELLO),
                onClick: this.handleLogin
            }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4jR19.default), (0, $kaECR.default).login))) : /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                xcss: $182fb7a040953fe9$var$loginButtonStyles
            }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $ccHMk.default), {
                onClick: this.handleLogin
            }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4jR19.default), (0, $kaECR.default).login))));
            if (reason.status === 403) return /*#__PURE__*/ (0, $3jLHL.jsx)($182fb7a040953fe9$var$ErrorMessage, null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4jR19.default), (0, $kaECR.default).errorTextUnverified));
            return /*#__PURE__*/ (0, $3jLHL.jsx)($182fb7a040953fe9$var$ErrorMessage, null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4jR19.default), (0, $kaECR.default).errorTextNetwork));
        }
        // Default error message
        return /*#__PURE__*/ (0, $3jLHL.jsx)($182fb7a040953fe9$var$ErrorMessage, null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4jR19.default), (0, $kaECR.default).errorText));
    }
    renderErrorHeading() {
        const { reason: reason } = this.state;
        if (!reason) return;
        if (reason.name === (0, $jIyl9.FETCH_ERROR_NAME) && reason.status === 401) return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4jR19.default), (0, $kaECR.default).errorHeadingLoggedOut);
        if (reason.name === (0, $jIyl9.FETCH_ERROR_NAME) && reason.status === 403) return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4jR19.default), (0, $kaECR.default).errorHeadingUnverified);
        return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4jR19.default), (0, $kaECR.default).errorHeading);
    }
    renderErrorImage() {
        const { intl: intl, product: product } = this.props;
        const { reason: reason } = this.state;
        if (product === (0, $dcO0p.Product).TRELLO) return /*#__PURE__*/ (0, $3jLHL.jsx)("img", {
            css: $182fb7a040953fe9$var$trelloErrorImgStyles,
            src: (0, $gjGxN.default),
            alt: intl.formatMessage((0, $kaECR.default).errorImageAltText)
        });
        if (reason.status === 403) return /*#__PURE__*/ (0, $3jLHL.jsx)("img", {
            css: $182fb7a040953fe9$var$unverifiedUserImageStyles,
            src: (0, $kyZGY.default),
            alt: intl.formatMessage((0, $kaECR.default).errorImageAltText)
        });
        return /*#__PURE__*/ (0, $3jLHL.jsx)($182fb7a040953fe9$var$RobotImage, {
            css: $182fb7a040953fe9$var$robotsImgStyles,
            alt: intl.formatMessage((0, $kaECR.default).errorImageAltText)
        });
    }
    render() {
        const { hideFallbackUI: hideFallbackUI } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && hideFallbackUI) return /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null);
        if (hasError) return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
            css: $182fb7a040953fe9$var$errorBoundaryBoxStyles,
            "data-testid": "error-boundary"
        }, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
            css: $182fb7a040953fe9$var$errorContentStyles
        }, this.renderErrorImage(), /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
            xcss: $182fb7a040953fe9$var$errorHeadingStyles
        }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $7hXDW.default), {
            size: "medium"
        }, this.renderErrorHeading())), this.renderErrorBody()));
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false
        };
        this.fireOperationalEvent = (payload)=>{
            if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                actionSubject: this.props.triggerSubject || $182fb7a040953fe9$var$TRIGGER_SUBJECT,
                ...payload
            }).fire((0, $a3xa0.NAVIGATION_CHANNEL));
        };
        this.handleLogin = (_, analyticsEvent)=>{
            analyticsEvent.update({
                eventType: (0, $7TH2w.UI_EVENT_TYPE),
                actionSubjectId: 'login'
            }).fire((0, $a3xa0.NAVIGATION_CHANNEL));
            if (this.props.product !== (0, $dcO0p.Product).TRELLO) window.location.reload();
        };
    }
}

const $182fb7a040953fe9$var$RobotImage = (props)=>{
    const [imgSrc, setImgSrc] = (0, $gwFzn.useState)();
    (0, $gwFzn.useEffect)(()=>{
        (parcelRequire("aOgb2")).then((src)=>setImgSrc(src.default));
    }, []);
    // eslint-disable-next-line jsx-a11y/alt-text
    return /*#__PURE__*/ (0, $3jLHL.jsx)("img", {
        ...props,
        src: imgSrc
    });
};
var $182fb7a040953fe9$export$2e2bcd8739ae039 = (0, $1DWH0.default)()((0, $js7oX.default)($182fb7a040953fe9$var$ErrorBoundary));

});
parcelRegister("gjGxN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9790e8d4108f316a$export$2e2bcd8739ae039);
var $9790e8d4108f316a$export$2e2bcd8739ae039 = 'data:image/svg+xml;base64,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';

});

parcelRegister("kyZGY", function(module, exports) {

$parcel$export(module.exports, "default", () => $de5b305fb7390b41$export$2e2bcd8739ae039);
var $de5b305fb7390b41$export$2e2bcd8739ae039 = `data:image/svg+xml;base64,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`;

});

parcelRegister("h2l3D", function(module, exports) {

$parcel$export(module.exports, "getLoginUrl", () => $3d203fedbb962cbf$export$8abe2e83e8d74da2);

var $dcO0p = parcelRequire("dcO0p");
var $3d203fedbb962cbf$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["Staging"] = "stg";
    Environment["Production"] = "prod";
    return Environment;
}({});
const $3d203fedbb962cbf$export$186d9db1ec46a9ca = (origin = window?.location?.origin)=>[
        'https://trello.com'
    ].includes(origin) ? "prod" : "stg";
const $3d203fedbb962cbf$var$getProduct = (product)=>{
    if (product) {
        const lowerJira = (0, $dcO0p.Product).JIRA.toLowerCase();
        const lowerProduct = product.toLowerCase();
        if (lowerProduct.includes(lowerJira)) return lowerJira;
        return lowerProduct;
    }
};
const $3d203fedbb962cbf$export$8abe2e83e8d74da2 = (productType, env = $3d203fedbb962cbf$export$186d9db1ec46a9ca(), continueUrl = String(window.location), loginHint)=>{
    const baseUrl = env === "prod" ? 'https://id.atlassian.com/login' : 'https://id.stg.internal.atlassian.com/login';
    const product = $3d203fedbb962cbf$var$getProduct(productType);
    return `${baseUrl}?continue=${encodeURIComponent(continueUrl)}${product ? `&application=${encodeURIComponent(product)}` : ''}
  ${loginHint ? `&login_hint=${encodeURIComponent(loginHint)}` : ''}`;
};

});

parcelRegister("kaECR", function(module, exports) {

$parcel$export(module.exports, "default", () => $952538c0e85b84fa$export$2e2bcd8739ae039);

var $2nPZH = parcelRequire("2nPZH");
const $952538c0e85b84fa$var$messages = (0, $2nPZH.defineMessages)({
    emptyStateExploreProductsTitle: {
        id: "fabric.atlassianSwitcher.emptyState.exploreProducts.title",
        defaultMessage: "Get started with cloud"
    },
    emptyStateExploreProductsBody: {
        id: "fabric.atlassianSwitcher.emptyState.exploreProducts.body",
        defaultMessage: "Try a product to start collaborating with your team."
    },
    emptyStateExploreProductsLink: {
        id: "fabric.atlassianSwitcher.emptyState.exploreProducts.link",
        defaultMessage: "Explore products"
    },
    home: {
        id: "fabric.atlassianSwitcher.atlassianHome",
        defaultMessage: "Home"
    },
    atlassianHome: {
        id: "fabric.atlassianSwitcher.home",
        defaultMessage: "Atlassian Home"
    },
    atlassianStart: {
        id: "fabric.atlassianSwitcher.start",
        defaultMessage: "Atlassian Start"
    },
    assets: {
        id: "fabric.atlassianSwitcher.assets",
        defaultMessage: "Assets"
    },
    analytics: {
        id: "fabric.atlassianSwitcher.analytics",
        defaultMessage: "Analytics"
    },
    companyHub: {
        id: "fabric.atlassianSwitcher.companyHub",
        defaultMessage: "Company Hub"
    },
    goals: {
        id: "fabric.atlassianSwitcher.goals",
        defaultMessage: "Goals"
    },
    teams: {
        id: "fabric.atlassianSwitcher.teams",
        defaultMessage: "Teams"
    },
    search: {
        id: "fabric.atlassianSwitcher.search",
        defaultMessage: "Search"
    },
    chat: {
        id: "fabric.atlassianSwitcher.chat",
        defaultMessage: "Chat"
    },
    studio: {
        id: "fabric.atlassianSwitcher.studio",
        defaultMessage: "Studio"
    },
    more: {
        id: "fabric.atlassianSwitcher.more",
        defaultMessage: "More"
    },
    manageList: {
        id: "fabric.atlassianSwitcher.manageList",
        defaultMessage: "Manage list"
    },
    jiraProject: {
        id: "fabric.atlassianSwitcher.jiraProject",
        defaultMessage: "Jira project"
    },
    confluenceSpace: {
        id: "fabric.atlassianSwitcher.confluenceSpace",
        defaultMessage: "Confluence space"
    },
    errorEmptyPartialResults: {
        id: "fabric.atlassianSwitcher.errorEmptyPartialResults",
        defaultMessage: "We can't display your apps right now."
    },
    errorHeading: {
        id: "fabric.atlassianSwitcher.errorHeading",
        defaultMessage: "Something\u2019s gone wrong"
    },
    errorText: {
        id: "fabric.atlassianSwitcher.errorText",
        defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things"
    },
    errorImageAltText: {
        id: "fabric.atlassianSwitcher.errorImageAltText",
        defaultMessage: "A broken robot and a number of people busy fixing it."
    },
    errorTextNetwork: {
        id: "fabric.atlassianSwitcher.errorTextNetwork",
        defaultMessage: "We couldn\u2019t load this list. Please reload the page and try again."
    },
    errorHeadingLoggedOut: {
        id: "fabric.atlassianSwitcher.errorHeadingLoggedOut",
        defaultMessage: "Your Atlassian account is logged out"
    },
    errorTextLoggedOut: {
        id: "fabric.atlassianSwitcher.errorTextLoggedOut",
        defaultMessage: "Log in again to use the Atlassian switcher."
    },
    errorHeadingUnverified: {
        id: "fabric.atlassianSwitcher.errorHeadingUnverified",
        defaultMessage: "Your account is unverified"
    },
    errorPartialResults: {
        id: "fabric.atlassianSwitcher.errorPartialResults",
        defaultMessage: "We can't display some of your apps right now."
    },
    errorPartialResultsRefresh: {
        id: "fabric.atlassianSwitcher.errorPartialResultsRefresh",
        defaultMessage: "Refresh the page, or try again later."
    },
    errorTextUnverified: {
        id: "fabric.atlassianSwitcher.errorTextUnverified",
        defaultMessage: "Please confirm your email address to view a list of available products."
    },
    login: {
        id: "fabric.atlassianSwitcher.login",
        defaultMessage: "Log in"
    },
    productDescriptionConfluence: {
        id: "fabric.atlassianSwitcher.product.description.confluence",
        defaultMessage: "Document collaboration"
    },
    productDescriptionJiraServiceManagement: {
        id: "fabric.atlassianSwitcher.product.description.jsm",
        defaultMessage: "Collaborative IT service management"
    },
    productDescriptionJiraSoftware: {
        id: "fabric.atlassianSwitcher.product.description.jsw",
        defaultMessage: "Project and issue tracking"
    },
    productDescriptionOpsgenie: {
        id: "fabric.atlassianSwitcher.product.description.opsgenie",
        defaultMessage: "Modern incident management"
    },
    productDescriptionCompass: {
        id: "fabric.atlassianSwitcher.product.description.compass",
        defaultMessage: "Component manager"
    },
    join: {
        id: "fabric.atlassianSwitcher.join",
        defaultMessage: "Join"
    }
});
var $952538c0e85b84fa$export$2e2bcd8739ae039 = $952538c0e85b84fa$var$messages;

});

parcelRegister("iFil1", function(module, exports) {

$parcel$export(module.exports, "SwitcherLoadErrorReason", () => $4775a99414f4d2cc$export$2c6136f6e27d3fdd);
$parcel$export(module.exports, "SwitcherLoadError", () => $4775a99414f4d2cc$export$ff0950b3c2e7f03e);

var $2PqoT = parcelRequire("2PqoT");
var $4775a99414f4d2cc$export$2c6136f6e27d3fdd = /*#__PURE__*/ function(SwitcherLoadErrorReason) {
    SwitcherLoadErrorReason["AVAILABLE_PRODUCTS"] = "availableProducts";
    SwitcherLoadErrorReason["PRODUCT_CONFIGURATION"] = "productConfiguration";
    return SwitcherLoadErrorReason;
}({});
class $4775a99414f4d2cc$export$ff0950b3c2e7f03e extends Error {
    reason() {
        const potentialResultError = this.resultError;
        return {
            ...(0, $2PqoT.errorToReason)(potentialResultError.error ? potentialResultError.error : this.resultError),
            source: this.errorReason
        };
    }
    constructor(errorReason, resultError){
        super();
        this.errorReason = void 0;
        this.resultError = void 0;
        this.errorReason = errorReason;
        this.resultError = resultError;
    }
}

});

parcelRegister("aOgb2", function(module, exports) {

let $7deb1f4b46250de3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7deb1f4b46250de3$var$load("2PUw9").then(()=>parcelRequire('6hgg7'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});





parcelRegister("88ga6", function(module, exports) {

$parcel$export(module.exports, "useExperienceSuccess", () => $bebaa2c4a150a593$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "useExperienceRenderAndMountMark", () => $bebaa2c4a150a593$export$fb30551804b67d63);
/* eslint-disable no-console */ 
var $9N1hJ = parcelRequire("9N1hJ");

var $gwFzn = parcelRequire("gwFzn");

var $dIWel = parcelRequire("dIWel");
function $bebaa2c4a150a593$export$675e0d25df38d426(experienceName, customStartTime) {
    const experienceTracker = (0, $9N1hJ.useExperienceTracker)();
    (0, $dIWel.useOnceImmediately)(()=>experienceTracker.start(experienceName, customStartTime));
}
function $bebaa2c4a150a593$export$e94f0da4fc0603c6(experience, attributes) {
    const experienceTracker = (0, $9N1hJ.useExperienceTracker)();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $gwFzn.useLayoutEffect)(()=>experienceTracker.success(experience, attributes), []);
}
function $bebaa2c4a150a593$export$fb30551804b67d63(mark) {
    const experienceTracker = (0, $9N1hJ.useExperienceTracker)();
    (0, $dIWel.useOnceImmediately)(()=>experienceTracker.markStart(mark));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $gwFzn.useLayoutEffect)(()=>experienceTracker.markEnd(mark), []);
}

});
parcelRegister("dIWel", function(module, exports) {

$parcel$export(module.exports, "useSingleton", () => $d2d6ce3394020471$export$abf4268d2dd55708);
$parcel$export(module.exports, "useOnceImmediately", () => $d2d6ce3394020471$export$ad4f8d0eee7a0e24);

var $gwFzn = parcelRequire("gwFzn");
function $d2d6ce3394020471$export$abf4268d2dd55708(builder) {
    const ref = (0, $gwFzn.useRef)();
    if (!ref.current) ref.current = builder();
    return ref.current;
}
function $d2d6ce3394020471$export$ad4f8d0eee7a0e24(callback) {
    const wasCalledRef = (0, $gwFzn.useRef)(false);
    const result = (0, $gwFzn.useRef)();
    if (!wasCalledRef.current) {
        wasCalledRef.current = true;
        result.current = callback();
    }
    return result.current;
}

});



parcelRegister("jgn9E", function(module, exports) {

let $e06178f5cdcfc50e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e06178f5cdcfc50e$var$load("6XyGC").then(()=>parcelRequire('cV69w'));

});

parcelRegister("2nZgg", function(module, exports) {

let $1bcd3ffb958d19d9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $1bcd3ffb958d19d9$var$load("8Afco"),
    $1bcd3ffb958d19d9$var$load("4fCJZ"),
    $1bcd3ffb958d19d9$var$load("dTsOE"),
    $1bcd3ffb958d19d9$var$load("gOlh9"),
    $1bcd3ffb958d19d9$var$load("a3B2V")
]).then(()=>parcelRequire('38oWY'));

});

parcelRegister("j27Sd", function(module, exports) {

let $ddb44fb5ced08b20$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ddb44fb5ced08b20$var$load("8Afco"),
    $ddb44fb5ced08b20$var$load("4fCJZ"),
    $ddb44fb5ced08b20$var$load("dTsOE"),
    $ddb44fb5ced08b20$var$load("gOlh9"),
    $ddb44fb5ced08b20$var$load("9B1r0")
]).then(()=>parcelRequire('ebk01'));

});

parcelRegister("2tou7", function(module, exports) {

let $1cd1486624322f66$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $1cd1486624322f66$var$load("8Afco"),
    $1cd1486624322f66$var$load("4fCJZ"),
    $1cd1486624322f66$var$load("dTsOE"),
    $1cd1486624322f66$var$load("gOlh9"),
    $1cd1486624322f66$var$load("kgItH")
]).then(()=>parcelRequire('gfMaa'));

});



//# sourceMappingURL=AppSwitcherComponentWrapper.5ab57176.js.map
